import React, {
  useEffect,
  useState,
  useMemo,
} from 'react';
import {
  Divider,
} from '@mui/material';
import PropTypes from 'prop-types';

import Product from '../../../../../../../Model/Product';
import { InfoTag } from '../../../../../../../components/Tags';
import InfoItem from '../../../InfoItem';
import {
  InfoContainer,
  InfoWrapper,
  StyledTitle,
  StyledAccordion,
  StyledArrowIcon,
} from '../../styles';
import { accordionId } from '../../utils';

import { FeaturesContainer } from './styles';
import texts from './texts';

const EMPTY_CELL = '-';

const ProductDetailsSection = ({
  userDoc,
  handleExpand,
  expanded,
  isQAP,
}) => {
  const [productDoc, setProductDoc] = useState(null);

  useEffect(() => {
    const init = async () => {
      if (userDoc.product && !productDoc) {
        const product = await Product.getById(userDoc.product);
        setProductDoc(product);
      }
    };

    init();
  }, [productDoc, userDoc.product]);

  const enabledFeatures = useMemo(() => {
    if (!productDoc) return [];
    const featuresConfig = productDoc.getFeaturesConfig();
    return featuresConfig.enabled.map((featureId) => texts[featureId]);
  }, [productDoc]);

  return (
    <>
      <Divider flexItem />
      <StyledAccordion
        key={texts.productDetails}
        title={<StyledTitle>{texts.productDetails}</StyledTitle>}
        expanded={(expanded === accordionId.PRODUCT_DETAILS_ACCORDION) || !isQAP}
        onChange={handleExpand(accordionId.PRODUCT_DETAILS_ACCORDION)}
        expandIcon={isQAP && <StyledArrowIcon />}
        preventRotation={!isQAP}
        disableGutters
      >
        <InfoContainer>
          <InfoWrapper>
            <InfoItem label={texts.productName}>
              {productDoc?.name || EMPTY_CELL}
            </InfoItem>
            <InfoItem label={texts.enabledFeatures}>
              {enabledFeatures.length > 0 ? (
                <FeaturesContainer>
                  {enabledFeatures.map((feature) => (
                    <InfoTag key={feature}>{feature}</InfoTag>
                  ))}
                </FeaturesContainer>
              ) : (
                texts.noFeaturesEnabled
              )}
            </InfoItem>
          </InfoWrapper>
        </InfoContainer>
      </StyledAccordion>
    </>
  );
};

ProductDetailsSection.propTypes = {
  userDoc: PropTypes.object.isRequired,
  handleExpand: PropTypes.func.isRequired,
  expanded: PropTypes.string.isRequired,
  isQAP: PropTypes.bool.isRequired,
};

export default ProductDetailsSection;
